











import { Component, Prop, Vue } from "vue-property-decorator";
import { ISpeciaMessage } from "@/@types/speciaMessage/speciaMessage";
import { auth } from "@/config/host.config";

import MessagePushForm from "./message-push-form.vue";
import MessageAlertForm from "./message-alert-form.vue";
import LanguagesButtons from "@/components/buttons/languages-buttons.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    LanguagesButtons,
    MessageAlertForm,
    MessagePushForm,
  },
})
class TvMailsForm extends Vue {
  @Prop({ type: String, default: "" }) type!: string;
  @Prop({ type: String, default: "" }) roomNumber!: string;

  locale = this.$store.getters.getLanguages[0];

  async send(alert: Partial<ISpeciaMessage>): Promise<void> {
    const uri = auth.message + "/" + this.roomNumber;
    try {
      const res = await this.$axios.post(uri, { alert });
      if (res.status === 200) {
        this.onSuccess();
        this.$bvModal.hide("tv-mails-form");
      }
    } catch (error) {
      console.log(error);
      this.onError();
    }
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  onSuccess(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("error.200")),
    });
  }
}
export default TvMailsForm;
